import {
  Affirm,
  ApplePay,
  Bancontact,
  Card,
  GooglePay,
  Klarna,
  PayByBank,
  PayByBankUS,
  PayPal,
  Redirect,
  Twint,
} from '@adyen/adyen-web';

import type { GatewayPaymentMethod, PaymentType } from '@/lib/payment/types';

const adyenComponentMap: Partial<Record<PaymentType, any>> = {
  affirm: Affirm,
  applepay: ApplePay,
  applepay_express: ApplePay,
  bcmc: Bancontact,
  card: Card,
  facilypay_3x: Redirect,
  facilypay_4x: Redirect,
  googlepay: GooglePay,
  ideal: Redirect,
  klarna_paynow: Klarna,
  paypal: PayPal,
  paybybank: PayByBank,
  paybybank_AIS_DD: PayByBankUS,
  scheme: Card,
  twint: Twint,
  visa: Card,
  zip: Redirect,
  alipay: Redirect,
  paywithgoogle: GooglePay,
  unionpay: Card,
};

export function createAdyenComponent(
  paymentType: PaymentType,
  checkoutInstance: any,
  config: any,
): GatewayPaymentMethod {
  const ComponentClass = adyenComponentMap[paymentType];

  if (!ComponentClass) {
    throw new Error(`Unsupported Adyen payment type: ${paymentType}`);
  }

  return new ComponentClass(checkoutInstance, config);
}
